import React, {useEffect, useState} from 'react';
import {user_data} from "../../../../../../../../components/functions/usr";
import axios from "axios";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import {header} from "../../../../../../../../components/api/Header";
import {gmslar, season_month} from "../../../../../../../../components/sfr/maydon";
import Info from "./Info";
import { getEnv } from "../../../../../../../../lib/env";

function Xisobot10(props) {
    const [swed, setSwed] = useState({})
    const [maydonlar, setMaydonlar] = useState({})
    const year = localStorage.getItem('sfr-hm-year')
    const user = user_data()
    const season = localStorage.getItem('sfr-hm-season')
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba?JSON.parse(manba):[]
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist?JSON.parse(ist):[]
    const ekin = localStorage.getItem("sfr-hm-"+season+"-ekinlar")
    const ekinlar = ekin?JSON.parse(ekin):{}
    const sfrMaydon = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const sfrMaydonlar = sfrMaydon?JSON.parse(sfrMaydon):{}
    const crops1 = localStorage.getItem('sfr-hm-'+season+'-ekinids')
    let cropids = crops1?JSON.parse(crops1):[]
    const may = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const maydon = may?JSON.parse(may):[]

    useEffect(()=>{
        let gmss = []
        const fetchSwed = async (gmss,gmss2) => {
            const postData = {
                crops:cropids,
                gmss,
                maydonlar:gmss2
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/veg_sugorish_meyyori4",
                postData,
                header(),
            )
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setSwed(res.data)
            }
        }
        const maydons = () => {
            let gidromodullar = []
            istemolchilar.map(i=>{
                if(i.gms){
                    i.gms.map(g=>{
                        if(!gidromodullar.includes(g)){
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydons()
        const gmss2 = gmslar(maydon,cropids)
        setMaydonlar(gmss2)
        if(gmss2)
            fetchSwed(gmss,gmss2)
    },[])

    const ff = (istemolchi) => {
        let res = {}
        let ee = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        let jem = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        Object.keys(ekinlar).map(e=>{
            ee = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
            for(let deks = 1; deks < 19; deks++){
                if(swed[e.slice(1)]){
                    istemolchi.map(ist => {
                        ist.gms.map(gms2=>{
                            if(swed[e.slice(1)][gms2]){
                                let im = sfrMaydonlar['i'+ist.id]?sfrMaydonlar['i'+ist.id]['g'+gms2]?sfrMaydonlar['i'+ist.id]['g'+gms2][e]:0:0
                                let ds = swed[e.slice(1)][gms2][deks]
                                ee[deks-1] = addFunc(ee[deks-1],im*ds)
                            }
                        })
                    })
                }
                jem[deks-1] = addFunc(jem[deks-1],ee[deks-1])
            }
            res[e] = ee
        })
        res['jami'] = jem
        return res
    }
    const xisobot = () => {
        let obj = [];
        let jjob = 0
        let emg = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        let jmeg = {}
        cropids = cropids?cropids.filter(ci=>ci!=19):[]
        manbalar.map((manba,i)=> {
            emg = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            let istemolchi = istemolchilar.filter(istemolchi => istemolchi.mid == manba.id)
            if (istemolchi.length) {
                let emeg = ff(istemolchi)
                if(i==0 && emeg){
                    jmeg = emeg
                    // jmeg.jami = emeg.jami
                }

                let job = 0
                obj.push(
                    <tr key={i+"a"}>
                        <td rowSpan={cropids.length*2+3} style={{verticalAlign:"baseline",position:"relative"}}>
                            <span style={{position:"sticky",top:"100px"}}>
                                {i+1}
                            </span>
                        </td>
                        <td rowSpan={cropids.length*2+3} style={{verticalAlign:"baseline", maxWidth:"100px",position:"relative"}}>
                            <span style={{position:"sticky",top:"100px"}}>
                                {manba.name}
                            </span>
                        </td>
                        <th rowSpan={2} className="text-start ps-2">Jami</th>
                        <th className="text-start ps-2">Dekada</th>
                        {
                            emeg['jami']?
                                emeg['jami'].map((jd,jindex)=>{
                                    return <th key={i+'j'+jindex}>{jd?fixIt(jd,1):''}</th>
                                })
                                :null
                        }
                    </tr>
                )
                obj.push(
                    <tr key={i+'b'}>
                        <th className="text-start ps-2">O'sib borishi</th>
                        {
                            emeg['jami']?
                                emeg['jami'].map((jd,jindex)=>{
                                    job = addFunc(job,jd)
                                    return <th key={i+'j'+jindex}>{job?fixIt(job,1):''}</th>
                                })
                                :null
                        }
                    </tr>
                )
                obj.push(
                    <tr key={i+'c'}>
                        <td colSpan={2} className="text-start ps-2">Shu jumladan</td>
                    </tr>
                )
                if(i>0){
                    if(jmeg['jami']){
                        for(var dekada = 0; dekada < 18; dekada++){
                            jmeg['jami'][dekada] = addFunc(jmeg['jami'][dekada],emeg['jami'][dekada])
                        }
                    }
                }
                cropids.map((cid,cindex)=>{
                    let ob = 0
                    if(i>0){
                        if(jmeg['e'+cid]){
                            for(var dekada = 0; dekada < 18; dekada++){
                                jmeg['e'+cid][dekada] = addFunc(jmeg['e'+cid][dekada],emeg['e'+cid][dekada])
                            }
                        }
                    }
                    obj.push(
                        <tr key={i+'d'+cindex}>
                            <td rowSpan={2} className="text-start ps-2" style={{maxWidth:"100px"}}>{ekinlar['e'+cid].name}</td>
                            <td className="text-start ps-2">Dekadalik</td>
                            {
                                emeg['e'+cid]?
                                    emeg['e'+cid].map((ed,eindex)=>{
                                        return <td key={i+'d'+cid+'e'+eindex}>{ed?fixIt(ed,1):''}</td>
                                    })
                                    :null
                            }
                        </tr>
                    )
                    obj.push(
                        <tr key={i+'ob'+cindex}>
                            <td className="text-start ps-2">O'sib boruvchi</td>
                            {
                                emeg['e'+cid]?
                                    emeg['e'+cid].map((ed,eindex)=>{
                                        ob = addFunc(ob,ed)
                                        return <td key={i+'o'+cid+'b'+eindex}>{ob?fixIt(ob,1):''}</td>
                                    })
                                    :null
                            }
                        </tr>
                    )
                })
            }
        })

        //jami
        obj.push(
            <tr key='jjami'>
                <th rowSpan={cropids.length*2+3} colSpan={2} style={{verticalAlign:"baseline", maxWidth:"100px",position:"relative"}}>
                            <span style={{position:"sticky",top:"100px"}}>
                                Jami
                            </span>
                </th>
                <th rowSpan={2} className="text-start ps-2">Jami</th>
                <th className="text-start ps-2">Dekada</th>
                {
                    jmeg['jami']?
                        jmeg['jami'].map((jd,jindex)=>{
                            return <th key={'jj'+jindex}>{fixIt(jd)}</th>
                        })
                        :null
                }
            </tr>
        )
        obj.push(
            <tr key="jamib">
                <th className="text-start ps-2">O'sib borishi</th>
                {
                    jmeg['jami']?
                        jmeg['jami'].map((jd,jindex)=>{
                            jjob = addFunc(jjob,jd)
                            return <th key={'jj'+jindex}>{jjob?fixIt(jjob,1):''}</th>
                        })
                        :null
                }
            </tr>
        )
        obj.push(
            <tr key="jamic">
                <th colSpan={2} className="text-start ps-2">Shu jumladan</th>
            </tr>
        )
        cropids.map((cid,cindex)=>{
            let ob = 0
            obj.push(
                <tr key={'jd'+cindex}>
                    <th rowSpan={2} className="text-start ps-2" style={{maxWidth:"100px"}}>{ekinlar['e'+cid].name}</th>
                    <th className="text-start ps-2">Dekadalik</th>
                    {
                        jmeg['e'+cid]?
                            jmeg['e'+cid].map((ed,eindex)=>{
                                return <th key={'jd'+cid+'e'+eindex}>{ed?fixIt(ed,1):''}</th>
                            })
                            :null
                    }
                </tr>
            )
            obj.push(
                <tr key={'job'+cindex}>
                    <th className="text-start ps-2">O'sib boruvchi</th>
                    {
                        jmeg['e'+cid]?
                            jmeg['e'+cid].map((ed,eindex)=>{
                                ob = addFunc(ob,ed)
                                return <th key={'jo'+cid+'b'+eindex}>{ob?fixIt(ob,1):''}</th>
                            })
                            :null
                    }
                </tr>
            )
        })
        //end jami

        return obj;
    }


    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-borderless m-0">
                    <thead>
                    <tr>
                        <td><h4 className="text-center">Xisobot - №5 a</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 className="text-center px-5">{user.district}ning {year} yil sug'orish davrida sug'orish ishlari JADVALI (fizik maydon)</h5>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="text-end pe-3">gektar / sug'orish</div>
                <div className="flex-box xisobot-table">
                    <div className="xisobotTable">
                        <table className="table table-bordered text-center xisobot3">
                            <thead className="sticky-top" style={{background:"#77adba",color:"#fff"}}>
                            <tr>
                                <th rowSpan={2}>No</th>
                                <th rowSpan={2}>Suv istemolchilari</th>
                                <th rowSpan={2} colSpan={2}>Ko'rsatgichlar</th>
                                {
                                    season_month(season).map((m,i)=>{
                                        return <th key={i} colSpan={3}>{m}</th>
                                    })
                                }
                            </tr>
                            <tr>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                            </tr>
                            </thead>
                            <tbody>
                            {xisobot()}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-2">
                <Info />
            </div>
        </div>
    );
}

export default Xisobot10;